import designHeroes from '../data/design-heroes.json';

export type AuthGalleryTile = {
  id: string;
  width: number;
  height: number;
};

const AUTH_GALLERY_TILE_COUNT = 32;
const AUTH_GALLERY_TILES: AuthGalleryTile[] = designHeroes;

export function createRandomAuthGalleryColumns(
  random: () => number = Math.random,
): AuthGalleryTile[][] {
  const shuffled = [...AUTH_GALLERY_TILES];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [
      shuffled[swapIndex],
      shuffled[index],
    ];
  }

  const columns: AuthGalleryTile[][] = [[], []];
  const columnHeights = [0, 0];

  for (const tile of shuffled.slice(0, AUTH_GALLERY_TILE_COUNT)) {
    const columnIndex = columnHeights[0] <= columnHeights[1] ? 0 : 1;
    columns[columnIndex].push(tile);
    columnHeights[columnIndex] += tile.height / tile.width;
  }

  return columns;
}

export function getAuthGalleryImageUrl(id: string): string {
  return `https://bymiles.ai/designs/images/heroes/${id}.webp`;
}
